/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryShowResponse2 } from '../../models/gallery-show-response-2';

export interface DeleteGalleryRemove$Params {
  name: string;
}

export function deleteGalleryRemove(http: HttpClient, rootUrl: string, params: DeleteGalleryRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, deleteGalleryRemove.PATH, 'delete');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryShowResponse2>;
    })
  );
}

deleteGalleryRemove.PATH = '/v1/gallery/{name}';
